module.exports = __webpack_public_path__ + "img/outsourcing-company-vs-recruiting-agency.b176d2d9.jpg";